import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex justify-center items-center pt-20">
      <div className="text-center">
        <h1 className="text-8xl font-extrabold text-color">404</h1>
        <p className="mt-4 text-xl text-alt-color">
          Oops! The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="px-6 py-3 text-color bg-tier-secondary hover:bg-dark-alt focus:outline-none focus:ring-4 focus:ring-dark-alt rounded-lg transition duration-300"
          >
            Go back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
